import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/utils/auth' 
import login from '@/components/login'
import pickuplocation from '@/components/pickuplocation'
import pickuplocation_mr from '@/components/pickuplocation_mr'
import adminuser from '@/components/adminuser'
import adminuser_mr from '@/components/adminuser_mr'
import rack from '@/components/rack'
import codcashmanage from '@/components/codcashmanage'
import printsticker from '@/components/printsticker'
//import thirdpartyshipment from '@/components/thirdpartyshipment'
import dashboard_adv from '@/components/dashboard_adv'
import dashboard_ksa from '@/components/dashboard_ksa'
import shipmentreport_ksa from '@/components/shipmentreport_ksa'
import futuredelivery from '@/components/futuredelivery'
import futuredeliveryreport from '@/components/futuredeliveryreport'
import hubexecute from '@/components/hubexecute'
import hubmaster from '@/components/hubmaster'
import hubtohub from '@/components/hubtohub'
import userwisefinince_dashboard from '@/components/userwisefinince_dashboard'
import riderwisefinince_dashboard from '@/components/riderwisefinince_dashboard'
import statusreport_adv from '@/components/statusreport_adv'
import runsheet from '@/components/runsheet'
import dayclosureuser from '@/components/dayclosureuser'
import approvepayment from '@/components/approvepayment'
import adddeliveryagent from '@/components/adddeliveryagent'
//import firstmileridermapping from '@/components/firstmileridermapping'
//import vendorcodes from '@/components/vendorcodes'
import rtsReport from '@/components/rtsReport'
import access from '@/components/access'
import pdaaccess from '@/components/pdaaccess'



//import bulkupload from '@/components/bulkupload'
import deliveryagentmaster from '@/components/deliveryagentmaster'
import deliveryagentmaster_mr from '@/components/deliveryagentmaster_mr'
import consignmentallocationpickup from '@/components/consignmentallocationpickup'
import reallocationpickup from '@/components/reallocationpickup'
import consignmenttracking from '@/components/consignmenttracking'
import consignmenttracking_mr from '@/components/consignmenttracking_mr'
import shipment_tracking from '@/components/shipment_tracking'
import dashboard from '@/components/dashboard'
import dashboard_mr from '@/components/dashboard_mr'

//import home from '@/components/home'
import rtoHandover from '@/components/rtohandover'
import displaymap from '@/components/displaymap'
import shipmentlocationtrack from '@/components/shipmentlocationtrack'

import MarkPickupCancel from '@/components/markpickupcancel'
import deliveryStatusReport from '@/components/deliverystatusreport'
import deliverystatusreport_mr from '@/components/deliverystatusreport_mr'

//import pickupstatusmaster from '@/components/pickupstatusmaster'
import misreport1 from '@/components/misreport1'
import misreport_adv from '@/components/misreport_adv'
import misreportfinance from '@/components/misreportfinance'
import mobilelogging from '@/components/mobilelogging'
import picknotassignedShipments from '@/components/picknotassignedShipments'
import delnotassignedShipments from '@/components/delnotassignedShipments'
import clientOnboard from '@/components/clientOnboard'
import clientList from '@/components/clientList'
import exceptionReport from '@/components/exceptionReport'
import exceptionReport_mr from '@/components/exceptionReport_mr'
import markBatchCancel from '@/components/markBatchCancel'
import reattemptshipments from '@/components/reattemptshipments'
import consignmentinscan from '@/components/consignmentinscan'
import consignmenthubinscan from '@/components/consignmenthubinscan'
import disbursmentReport from '@/components/disbursmentReport'
import previousmisreport from '@/components/previousmisreport'
import undeliveredshipmentstatus from '@/components/undeliveredshipmentstatus'
import codReports from '@/components/codReports'

import codSRDayClosure from '@/components/codSRDayClosure'
import codHubClosureReport from '@/components/codHubClosureReport'
import codmisreport from '@/components/codmisreport'
import CONSTANTS from '@/utils/constants'
import receiptTracker from '@/components/receiptTracker'
//import markdeliverystatus from '@/components/markdeliverystatus'
import updatepincodeagainshipmentid from '@/components/updatepincodeagainshipmentid'
import removeshipment from '@/components/removeshipment'
import misreport from '@/components/misreport'
import bulkallocation from '@/components/bulkallocation'
import shipmentreport from '@/components/shipmentreport'
import InScanrack from '@/components/InScanrack'
import ndrscanrack from '@/components/ndrscanrack'
import pushcustomlog from '@/components/pushcustomlog'
import pushlogisticstatus from '@/components/pushlogisticstatus'
import zonemaster from '@/components/zonemaster'
import pincodes from '@/components/pincodes'
import firstmileridermapping from '@/components/firstmileridermapping'
import vendorcodes from '@/components/vendorcodes'
import reallocatepallet from '@/components/reallocatepallet'
import palletinfo1 from '@/components/palletinfo1'
import managePallets from '@/components/managePallets'
import zonenames from '@/components/zonenames'
import Vendorrejectlist from '@/components/Vendorrejectlist'
import master_awb from '@/components/master_awb'
import LineHaulPalletlisting from '@/components/LineHaulPalletlisting'
import masterawblisting from '@/components/masterawblisting'
import mezonemanagement from '@/components/mezonemanagement'
import misreport_adv_new from '@/components/misreport_adv_new'
import misreport_me from '@/components/misreport_me'
import masterawbdetails from '@/components/masterawbdetails'
import bulkshipment from '@/components/bulkshipment'
import shipment_masterawb from '@/components/shipment_masterawb'
import rvpallocation from '@/components/rvpallocation' 
import cdm_deposit from '@/components/cdm_deposit' 
import markdelivery from '@/components/markdelivery'
import requestdelivery from '@/components/requestdelivery'
import pod_proof from '@/components/pod_proof'
import datewise_pendingreport from '@/components/datewise_pendingreport'
import claimwise_listing from '@/components/claimwise_listing'
import me_skyexpress from '@/components/me_skyexpress'
import skyex_shipment_tracking from '@/components/skyex_shipment_tracking'
import riderwiseofd from '@/components/riderwiseofd'
import warrentyshipmentreport from '@/components/warrentyshipmentreport'
import dub_skyexpress from '@/components/dub_skyexpress'
import riderMeterreadinglog from '@/components/riderMeterreadinglog'
import hubInscan from '@/components/hubInscan'
import hubmaster_ksa from '@/components/hubmaster_ksa'
import masterawblisting_Ksa from '@/components/masterawblisting_Ksa'
import petrolBill from '@/components/petrolBill'
import ksa_skyexpress from '@/components/ksa_skyexpress'
import crosscountryshipmentreport from '@/components/crosscountryshipmentreport'
import Travel_Tracking from '@/components/Travel_Tracking'
import MasterAwb_KSA from '@/components/MasterAwb_KSA'
import ofd_unique_customer from '@/components/ofd_unique_customer'
import bulkrtd from '@/components/bulkrtd'
import tobeofd from '@/components/tobe_ofd'
import superadmin_dashboard from '@/components/superadmin_dashboard'
import superad_shipmentreport from '@/components/superad_shipmentreport'
import crosscountrysuperad_shipmentreport from '@/components/crosscountrysuperad_shipmentreport'
import ofd_report from '@/components/ofd_report'
import audit_scandetails from '@/components/audit_scandetails'
import pickCancelToCpc from '@/components/pickCancelToCpc'
import marklostshipment from '@/components/marklostshipment'
import financeReport from '@/components/financeReport'
import codCollection_closure from '@/components/codCollection_closure'
import codExpense from '@/components/codExpense'

import performanceReport from '@/components/performanceReport'
import approvePayment_KSA from '@/components/approvePayment_KSA'
import financeCODReport from '@/components/financeCODReport'

import performanceReport_KSA from '@/components/performanceReport/performanceReport_KSA'
import performanceReport_KSA_new from '@/components/performanceReport_new/performanceReport_KSA_new'
import versionmgmt from '@/components/versionmgmt'


import wronglyDeliveredClearance from '@/components/wronglyDeliveredClearance.vue'
import dashboard_quick from '../components/dashboard_quick.vue'
import dashboard_adv_quick from '../components/dashboard_adv_quick.vue'
import quickdetails from '../components/qwik/quickdetails'
import qwik_reallocationpickup from '../components/qwik/qwik_reallocationpickup.vue'
import qwik_printsticker  from '../components/qwik/qwik_printsticker.vue'
import qwik_rvpallocation from '../components/qwik/qwik_rvpallocation.vue'
import qwik_ndrrackinscan from '../components/qwik/qwik_ndrrackinscan.vue'
import qwikcodSRDayClosure from '../components/qwik/qwikcodSRDayClosure.vue'
import qwik_deliveryagentmastermr from '../components/qwik/qwik_deliveryagentmastermr.vue'
import qwick_consignmenttrackingmr from '../components/qwik/qwick_consignmenttrackingmr.vue'
import qwik_adddeliveryagent from '../components/qwik/qwik_adddeliveryagent.vue'
// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
//const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode hash
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
    path: '/',
    component: DefaultContainer,
    redirect:'login',
    children: [
        {
        path: '/',
        name: 'dashboard_mr',
        component: dashboard_mr
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: dashboard,
          beforeEnter: requireAuth
        },
        {
          path: 'dashboard_mr',
          name: 'dashboard_mr',
          component: dashboard_mr,
          beforeEnter: requireAuth
        },
         {
          path: 'dashboard_adv',
          name: 'dashboard_adv',
          component: dashboard_adv,
        beforeEnter: requireAuth
      },
      {
        path: 'dashboard_ksa',
        name: 'dashboard_ksa',
        component: dashboard_ksa,
        beforeEnter: requireAuth
      },
      {
        path: 'shipmentreport_ksa',
        name: 'shipmentreport_ksa',
        component: shipmentreport_ksa,
          beforeEnter: requireAuth
        },

        {
          path: 'bulkallocation',
          name: 'Bulk Allocation',
          component: bulkallocation,
          beforeEnter: requireAuth
        },
        {
          path: 'pickuplocation',
          name: 'pickuplocation',
          component: pickuplocation,
          beforeEnter: requireAuth
        },
        {
          path: 'pickuplocation_mr',
          name: 'pickuplocation_mr',
          component: pickuplocation_mr,
          beforeEnter: requireAuth
        }, 
        {
          path: 'pushcustomlog',
          name: 'pushcustomlog',
          component: pushcustomlog,
          beforeEnter: requireAuth
        },
        {
          path: 'pushlogisticstatus',
          name: 'pushlogisticstatus',
          component: pushlogisticstatus,
          beforeEnter: requireAuth
        },
        

          
        

        {
          path: 'shipmentreport/:id',
          name: 'shipmentreport',
          component: shipmentreport,
          beforeEnter: requireAuth
        },
         {
          path: 'adminuser',
          name: 'adminuser',
          component: adminuser,
          beforeEnter: requireAuth
        },
         {
          path: 'adminuser_mr/:id',
          name: 'adminuser_mr',
          component: adminuser_mr,
          beforeEnter: requireAuth
        },

        
        {
      path: '/receiptTracker',
      name: 'receiptTracker',
      component: receiptTracker,
      beforeEnter: requireAuth
        },

        {
          path: 'rack',
          name: 'rack',
          component: rack,
          beforeEnter: requireAuth
        },
        
        {
          path: 'printsticker',
          name: 'printsticker',
          component: printsticker,
          beforeEnter: requireAuth
        },
        {
          path: 'runsheet',
          name: 'runsheet',
          component: runsheet,
          beforeEnter: requireAuth
        },
        
        {
          path: 'codcashmanage',
          name: 'codcashmanage',
          component: codcashmanage,
          beforeEnter: requireAuth
        },        
        // {
        //   path: 'thirdpartyshipment',
        //   name: 'thirdpartyshipment',
        //   component: thirdpartyshipment,
        //   beforeEnter: requireAuth
        // },                 
         {
          path: 'hubexecute',
          name: 'hubexecute',
          component: hubexecute,
          beforeEnter: requireAuth
        },
         {
          path: 'hubmaster',
          name: 'hubmaster',
          component: hubmaster,
          beforeEnter: requireAuth
        },
         {
          path: 'hubtohub',
          name: 'hubtohub',
          component: hubtohub,
          beforeEnter: requireAuth
        },
        // {
        //   path: 'bulkupload',
        //   name: 'bulkupload',
        //   component: bulkupload,
        //   beforeEnter: requireAuth
        // },


        {
      path: 'displaymap',
      name: 'displaymap',
      component: displaymap,
      beforeEnter: requireAuth
    }, 

    {
      path: '/deliveryagentmaster',
      name: 'deliveryagentmaster',
      component: deliveryagentmaster,
      beforeEnter: requireAuth
    }, 
     {
      path: '/deliveryagentmaster_mr',
      name: 'deliveryagentmaster_mr',
      component: deliveryagentmaster_mr,
      beforeEnter: requireAuth
    }, 
    {
          path: 'adddeliveryagent',
          name: 'Add',
          component: adddeliveryagent,
          beforeEnter: requireAuth
    },
    {

      path: '/dayclosureuser',
      name: 'dayclosureuser',
      component: dayclosureuser,
      beforeEnter: requireAuth
    },
    {

      path: '/approvepayment',
      name: 'approvepayment',
      component: approvepayment,
      beforeEnter: requireAuth
    },


    {
      path: '/consignmenttracking',
      name: 'consignmenttracking',
      component: consignmenttracking,
      beforeEnter: requireAuth
    }, 
     {
      path: '/consignmenttracking_mr',
      name: 'consignmenttracking_mr',
      component: consignmenttracking_mr,
      beforeEnter: requireAuth
    }, 
    {
        path: '/shipment_tracking',
        name: 'shipment_tracking',
        component: shipment_tracking,
        beforeEnter: requireAuth
      },
     {
      path: '/shipmentlocationtrack',
      name: 'shipmentlocationtrack',
      component: shipmentlocationtrack,
      beforeEnter: requireAuth
    },

    {
      path: '/rtoHandover',
      name: 'rtoHandover',
      component: rtoHandover,
      beforeEnter: requireAuth
    }, {
      path: '/MarkPickupCancel',
      name: 'MarkPickupCancel',
      component: MarkPickupCancel,
      beforeEnter: requireAuth
    },

   
     {
      path: '/deliveryStatusReport',
      name: 'deliveryStatusReport',
      component: deliveryStatusReport,
      beforeEnter: requireAuth
    }, 

    {
      path: '/deliverystatusreport_mr',
      name: 'deliverystatusreport_mr',
      component: deliverystatusreport_mr,
      beforeEnter: requireAuth
    }, 



    {
      path: '/disbursmentReport',
      name: 'disbursmentReport',
      component: disbursmentReport,
      beforeEnter: requireAuth
    },
    {
     path: '/previousmisreport',
     name: 'previousmisreport',
     component: previousmisreport,
     beforeEnter: requireAuth
   },
     {
      path: '/consignmentallocationpickup',
      name: 'consignmentallocationpickup',
      component: consignmentallocationpickup,
      beforeEnter: requireAuth
    },


    //  {
    //   path: '/pickupstatusmaster',
    //   name: 'pickupstatusmaster',
    //   component: pickupstatusmaster,
    //   beforeEnter: requireAuth
    // }, 


    {
      path: '/misreport1',
      name: 'misreport1',
      component: misreport1,
      beforeEnter: requireAuth
    }, 
    {
      path: '/misreport_adv',
      name: 'misreport_adv',
      component: misreport_adv,
      beforeEnter: requireAuth
    }, 

    {
      path: '/misreport_adv_new',
      name: 'misreport_adv_new',
      component: misreport_adv_new,
      beforeEnter: requireAuth
    },
 
	{
      path: '/misreport_me',
      name: 'misreport_me',
      component: misreport_me,
      beforeEnter: requireAuth
    },   



	{
      path: '/misreport',
      name: 'misreport',
      component: misreport,
      beforeEnter: requireAuth
    },
    {
      path: '/futuredelivery',
      name: 'futuredelivery',
      component: futuredelivery,
      beforeEnter: requireAuth
    },
    {
      path: '/userwisefinince_dashboard',
      name: 'userwisefinince_dashboard',
      component: userwisefinince_dashboard,
      beforeEnter: requireAuth
    },
     {
      path: '/riderwisefinince_dashboard',
      name: 'riderwisefinince_dashboard',
      component: riderwisefinince_dashboard,
      beforeEnter: requireAuth
    },


    {
      path: '/misreportfinance',
      name: 'misreportfinance',
      component: misreportfinance,
      beforeEnter: requireAuth
    },

     {
      path: '/mobilelogging',
      name: 'mobilelogging',
      component: mobilelogging,
      beforeEnter: requireAuth
    }, {
      path: '/picknotassignedShipments',
      name: 'picknotassignedShipments',
      component: picknotassignedShipments,
      beforeEnter: requireAuth
    }, {
      path: '/delnotassignedShipments',
      name: 'delnotassignedShipments',
      component: delnotassignedShipments,
      beforeEnter: requireAuth
    }, {
      path: '/clientOnboard/:id?/:mode?',
      name: 'clientOnboard',
      component: clientOnboard,
      beforeEnter: requireAuth
    }, 

    {
      path: '/exceptionReport',
      name: 'exceptionReport',
      component: exceptionReport,
      beforeEnter: requireAuth
    },
    {
      path: '/exceptionReport_mr',
      name: 'exceptionReport_mr',
      component: exceptionReport_mr,
      beforeEnter: requireAuth
    },
    {
      path: '/clientList',
      name: 'clientList',
      component: clientList,
      beforeEnter: requireAuth
    },
    {
      path: '/reallocationpickup',
      name: 'reallocationpickup',
      component: reallocationpickup,
      beforeEnter: requireAuth
    },
    {
    path: '/riderwiseofd',
    name: 'riderwiseofd',
    component: riderwiseofd,
    beforeEnter: requireAuth
    },
    // {
    //       path: 'firstmileridermapping',
    //       name: 'firstmileridermapping',
    //       component: firstmileridermapping,
    //       beforeEnter: requireAuth
    //     }, 
        //   {
        //   path: 'vendorcodes',
        //   name: 'vendorcodes',
        //   component: vendorcodes,
        //   beforeEnter: requireAuth
        // },
         {
          path: 'rtsReport',
          name: 'rtsReport',
          component: rtsReport,
          beforeEnter: requireAuth
        },
        
    {
      path: '/reattemptshipments',
      name: 'reattemptshipments',
      component: reattemptshipments,
      beforeEnter: requireAuth
    },
    {
      path: '/consignmentinscan',
      name: 'consignmentinscan',
      component: consignmentinscan,
      beforeEnter: requireAuth
    },
    {
      path: '/consignmenthubinscan',
      name: 'consignmenthubinscan',
      component: consignmenthubinscan,
      beforeEnter: requireAuth      
    },
    {
      path: '/markBatchCancel',
      name: 'markBatchCancel',
      component: markBatchCancel,
      beforeEnter: requireAuth
    },
    {
      path: '/undeliveredshipmentstatus',
      name: 'undeliveredshipmentstatus',
      component: undeliveredshipmentstatus,
      beforeEnter: requireAuth
    },
    {
      path: '/codReports',
      name: 'codReports',
      component: codReports,
      beforeEnter: requireAuth
    },
    {

      path: '/codSRDayClosure',
      name: 'codSRDayClosure',
      component: codSRDayClosure,
      beforeEnter: requireAuth
    },
    {
      path: '/codHubClosureReport',
      name: 'codHubClosureReport',
      component: codHubClosureReport,
      beforeEnter: requireAuth
    },
    {
      path: '/codmisreport',
      name: 'codmisreport',
      component: codmisreport,
      beforeEnter: requireAuth
    },
    {

      path: '/updatepincodeagainshipmentid',
      name: 'updatepincodeagainshipmentid',
      component: updatepincodeagainshipmentid,
      beforeEnter: requireAuth
    },
    {
    path: '/statusreport_adv',
    name: 'statusreport_adv',
    component: statusreport_adv,
    beforeEnter: requireAuth
    },

    {
      path: '/removeshipment',
      name: 'removeshipment',
      component: removeshipment,
      beforeEnter: requireAuth
    },
        {
          path: 'InScanrack',
          name: 'InScanrack',
          component: InScanrack,
          beforeEnter: requireAuth
        },
         {
          path: 'ndrscanrack',
          name: 'ndrscanrack',
          component: ndrscanrack,
          beforeEnter: requireAuth
        },
        {
     path: '/zonemaster',
    name: 'zonemaster',
    component: zonemaster,
    beforeEnter: requireAuth
    },
    {
    path: '/pincodes',
    name: 'pincodes',                          
    component: pincodes,
    beforeEnter: requireAuth
    },
    {
          path: 'firstmileridermapping',
          name: 'firstmileridermapping',
          component: firstmileridermapping,
          beforeEnter: requireAuth
        }, 
          {
          path: 'vendorcodes',
          name: 'vendorcodes',
          component: vendorcodes,
          beforeEnter: requireAuth
        },
        {
          path: 'reallocatepallet',
          name: 'reallocatepallet',
          component: reallocatepallet,
          beforeEnter: requireAuth
        }, 
        {
          path: 'palletinfo1',
          name: 'palletinfo1',
          component: palletinfo1,
          beforeEnter: requireAuth
        }, 
          {
    path: '/managePallets',
    name: 'managePallets',
    component: managePallets,
    beforeEnter: requireAuth
    },
      {
          path: 'zonenames',
          name: 'zonenames',
          component: zonenames,
          beforeEnter: requireAuth
        },
        
         {
          path: 'Vendorrejectlist',
          name: 'Vendorrejectlist',
          component: Vendorrejectlist,
          beforeEnter: requireAuth
        },
         {
          path: 'master_awb',
          name: 'master_awb',
          component: master_awb,
          beforeEnter: requireAuth
        },
        {
          path: 'LineHaulPalletlisting',
          name: 'LineHaulPalletlisting',
          component: LineHaulPalletlisting,
          beforeEnter: requireAuth
        },
        {
        
          path: 'masterawblisting/:id?',
          name: 'masterawblisting',
          component: masterawblisting,
          beforeEnter: requireAuth
        },
        
        
         {
          path: 'access/:id/',
          name: 'access',
          component: access,
          beforeEnter: requireAuth
        }, 
        {
          path: 'pdaaccess/:id/',
          name: 'pdaaccess',
          component: pdaaccess,
          beforeEnter: requireAuth
        },
        {
          path: 'mezonemanagement',
          name: 'mezonemanagement',
          component: mezonemanagement,
          beforeEnter: requireAuth
        },
        {
          path: '/masterawbdetails',
          name: 'masterawbdetails',
          component: masterawbdetails,
          beforeEnter: requireAuth
        },
        {
          path: '/bulkshipment',
          name: 'bulkshipment',
          component: bulkshipment,
          beforeEnter: requireAuth
        },
        {
          path: '/shipment_masterawb',
          name: 'shipment_masterawb',
          component: shipment_masterawb,
          beforeEnter: requireAuth
        },
        {
          path: '/rvpallocation',
          name: 'rvpallocation',
          component: rvpallocation,
          beforeEnter: requireAuth
        }, 
        {
          path: '/cdm_deposit',
          name: 'cdm_deposit',
          component: cdm_deposit,
          beforeEnter: requireAuth
        },
        {
          path: '/markdelivery',
          name: 'markdelivery',
          component: markdelivery,
          beforeEnter: requireAuth
        },
         {
          path: '/requestdelivery',
          name: 'requestdelivery',
          component: requestdelivery,
          beforeEnter: requireAuth
        }, 
        {
          path: '/pod_proof',
          name: 'pod_proof',
          component: pod_proof,
          beforeEnter: requireAuth
        },
        {
          path: '/datewise_pendingreport',
          name: 'datewise_pendingreport',
          component: datewise_pendingreport,
          beforeEnter: requireAuth
        },
         {
          path: '/claimwise_listing',
          name: 'claimwise_listing',
          component: claimwise_listing,
          beforeEnter: requireAuth
        },
        {
          path: '/me_skyexpress',
          name: 'me_skyexpress',
          component: me_skyexpress,
          beforeEnter: requireAuth
          },
          {
          path: '/skyex_shipment_tracking',
          name: 'skyex_shipment_tracking',
          component: skyex_shipment_tracking,
          beforeEnter: requireAuth
          },
          {
          path: 'warrentyshipmentreport/:id',
          name: 'warrentyshipmentreport',
          component: warrentyshipmentreport,
          beforeEnter: requireAuth
          },
          {
          path: '/dub_skyexpress',
          name: 'dub_skyexpress',
          component: dub_skyexpress,
          beforeEnter: requireAuth
          },
          {
          path: '/riderMeterreadinglog',
          name: 'riderMeterreadinglog',
          component: riderMeterreadinglog,
          beforeEnter: requireAuth
          },
          {
        path: '/hubInscan',
        name: 'hubInscan',
        component: hubInscan,
        beforeEnter: requireAuth
        },
        {
        path: '/hubmaster_ksa',
        name: 'hubmaster_ksa',
        component: hubmaster_ksa,
        beforeEnter: requireAuth
        },
        {
        path: '/masterawblisting_Ksa',
        name: 'masterawblisting_Ksa',
        component: masterawblisting_Ksa,
        beforeEnter: requireAuth
        },
        {
        path: '/petrolBill',
        name: 'petrolBill',
        component: petrolBill,
        beforeEnter: requireAuth
        },
        {
        path: '/ksa_skyexpress',
        name: 'ksa_skyexpress',
        component: ksa_skyexpress,
        beforeEnter: requireAuth
        },
        {
        path: '/ksa_skyexpress',
        name: 'ksa_skyexpress',
        component: ksa_skyexpress,
        beforeEnter: requireAuth
        },
         {
          path: 'crosscountryshipmentreport/:id',
          name: 'crosscountryshipmentreport',
          component: crosscountryshipmentreport,
          beforeEnter: requireAuth
        },
        {
        path: '/Travel_Tracking',
        name: 'Travel_Tracking',
        component: Travel_Tracking,
        beforeEnter: requireAuth
        },
        {
        path: '/MasterAwb_KSA',
        name: 'MasterAwb_KSA',
        component: MasterAwb_KSA,
        beforeEnter: requireAuth
        },
        {
        path: '/ofd_unique_customer',
        name: 'ofd_unique_customer',
        component: ofd_unique_customer,
        beforeEnter: requireAuth
        },
        {

          path: '/bulkrtd',
          name: 'bulkrtd',
          component: bulkrtd,
          beforeEnter: requireAuth
        },
        {
          path: '/tobe_ofd',
          name: 'tobe_ofd',
          component: tobeofd,
          beforeEnter: requireAuth
        },
        {
          path: '/superadmin_dashboard',
          name: 'superadmin_dashboard',
          component: superadmin_dashboard,
          beforeEnter: requireAuth
        },
        {
          path: 'superad_shipmentreport/:id',
          name: 'superad_shipmentreport',
          component: superad_shipmentreport,
          beforeEnter: requireAuth
        },
        {
          path: 'crosscountrysuperad_shipmentreport/:id',
          name: 'crosscountrysuperad_shipmentreport',
          component: crosscountrysuperad_shipmentreport,
          beforeEnter: requireAuth
        },

        {
          path: 'ofd_report',
          name: 'ofd_report',
          component: ofd_report,
          beforeEnter: requireAuth
        },
        {
          path: 'audit_scandetails',
          name: 'audit_scandetails',
          component: audit_scandetails,
          beforeEnter: requireAuth
        },
        {
          path: '/pickCancelToCpc',
          name: 'pickCancelToCpc',
          component: pickCancelToCpc,
          beforeEnter: requireAuth
        },
        {
          path: '/marklostshipment',
          name: 'marklostshipment',
          component: marklostshipment,
          beforeEnter: requireAuth
        },
        {
          path: '/financeReport',
          name: 'financeReport',
          component: financeReport,
          beforeEnter: requireAuth
        },

        {
          path: '/codCollection_closure',
          name: 'codCollection_closure',
          component: codCollection_closure,
          beforeEnter: requireAuth
        },
  
        {
          path: '/codExpense',
          name: 'codExpense',
          component: codExpense,
          beforeEnter: requireAuth
        },
        // pranali's code end
  
        // Aniket code start
        {
           path: '/performanceReport',
           name: 'performanceReport',
           component: performanceReport,
           beforeEnter: requireAuth
         },
  
        {
          path: '/approvePayment_KSA',
          name: 'approvePayment_KSA',
          component: approvePayment_KSA,
          beforeEnter: requireAuth
        },
  
         {
           path: '/financeCODReport',
           name: 'financeCODReport',
           component: financeCODReport,
           beforeEnter: requireAuth
         },

         {
          path: '/performanceReport_KSA',
          name: 'performanceReport_KSA',
          component: performanceReport_KSA,
          beforeEnter: requireAuth
         },
      {
        path: '/performanceReport_KSA_new',
        name: 'performanceReport_KSA_new',
        component: performanceReport_KSA_new,
        beforeEnter: requireAuth
      },
      {
        path: '/versionmgmt',
        name: 'versionmgmt',
        component: versionmgmt,
        beforeEnter: requireAuth
      },
        // Aniket code end
        


      {
        path: '/wronglyDeliveredClearance',
        name: 'Wrongly Delivered Clearance',
        component: wronglyDeliveredClearance,
        beforeEnter: requireAuth
      },
      {
        path: '/dashboard_quick',
        name: 'dashboard_quick',
        component: dashboard_quick,
        beforeEnter: requireAuth
      },
      {
        path: '/dashboard_adv_quick/:id',
        name: 'dashboard_adv_quick',
        component: dashboard_adv_quick,
        beforeEnter: requireAuth
      },
      {
        path: '/quickdetails',
        name: 'quickdetails',
        component: quickdetails,
        beforeEnter: requireAuth
      },
      {
        path: '/qwik_reallocationpickup',
        name: 'qwik_reallocationpickup',
        component: qwik_reallocationpickup,
        beforeEnter: requireAuth
      },
      {
        path: '/qwik_rvpallocation',
        name: 'qwik_rvpallocation',
        component: qwik_rvpallocation,
        beforeEnter: requireAuth
      },
      {
        path: '/qwik_printsticker',
        name: 'qwik_printsticker',
        component: qwik_printsticker,
        beforeEnter: requireAuth
      },
      {
        path: '/qwik_ndrrackinscan',
        name: 'qwik_ndrrackinscan',
        component: qwik_ndrrackinscan,
        beforeEnter: requireAuth
      },
      {
        path: '/qwikcodSRDayClosure',
        name: 'qwikcodSRDayClosure',
        component: qwikcodSRDayClosure,
        beforeEnter: requireAuth
      },
      {
        path: '/qwik_deliveryagentmastermr/:id',
        name: 'qwik_deliveryagentmastermr',
        component: qwik_deliveryagentmastermr,
        beforeEnter: requireAuth
      },
      {
        path: '/qwick_consignmenttrackingmr/:id',
        name: 'qwick_consignmenttrackingmr',
        component: qwick_consignmenttrackingmr,
        beforeEnter: requireAuth
      },
      {
        path: '/qwik_adddeliveryagent/:id',
        name : 'qwik_adddeliveryagent',
        component: qwik_adddeliveryagent,
        beforeEnter: requireAuth
      }
    ]
  }, {
    path: '/login',
    name: 'login',
    component: login
  }]
})
router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    if(to.name!='superadmin_dashboard' && to.name!='superad_shipmentreport' && to.name!='crosscountryshipmentreport'){
      localStorage.setItem('SelectHub', '')
      }
      // Start the route progress bar.
      NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
function requireAuth (to, from, next) {
  var chkauth = auth.loggedIn()
  if (auth.loggedIn()) {
    next({
      path: '/login'
    })
  } else {
    next()
  }
}

// function requireAuthCod(to, from, next) {
//     const axios = require('axios')
//     //console.log('url:',CONSTANTS.API_URL);
//     axios.post(`${CONSTANTS.API_URL}/ValidateSystemUserLogin`,{sysemailid:"p2pcod@xpressbees.com",syspassword:"$p2pcod$"})
//     .then(response => {
//         if(response.data.returnmsg === 'successful'){
//             let userData = response.data.returnvalue[0];
//             // console.log('data: ', userData);
//             localStorage.setItem('userData', JSON.stringify(userData))
//             localStorage.setItem('Coduser', "codvaliduser")
//             var d1 = new Date()
//             localStorage.setItem('activeTime', d1.getMinutes())
//             Vue.http.headers.common['x-access-token']  = userData['token'];
//             next()
//         }
//     })
// }